import { render, staticRenderFns } from "./SendMoney.vue?vue&type=template&id=f6e32f48&"
import script from "./SendMoney.vue?vue&type=script&lang=js&"
export * from "./SendMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports